import React from 'react';
import { Grid } from '@material-ui/core';
import Table from '../../Table/Table';
import Button from 'components/CustomButtons/Button.jsx';
import PageTitle from '../../inc/PageTitle';
import { Link, Redirect } from 'react-router-dom';

class StoryList extends React.Component {
  constructor(props) {
    super(props);
    this.mapUserStoriesToTable = this.mapUserStoriesToTable.bind(this);
    this.editButton = this.editButton.bind(this);
    this.duplicateButton = this.duplicateButton.bind(this);
    this.getActionButtons = this.getActionButtons.bind(this);
    this.state = {
      redirectToCreateStory:
        !props.userStories || props.userStories.length === 0,
    };
  }

  duplicateButton(storyId) {
    const projectId = this.props.sprint.project;
    const sprintId = this.props.sprint._id;
    return (
      <Link
        to={`/projects/${projectId}/sprints/${sprintId}/duplicate-story/${storyId}`}
      >
        <Button round={true} size={'sm'} color={'default'}>
          Duplicate
        </Button>
      </Link>
    );
  }

  editButton(storyId, storyIndex) {
    const projectId = this.props.sprint.project;
    const sprintId = this.props.sprint._id;
    return (
      <Link
        to={`/projects/${projectId}/sprints/${sprintId}/stories/${storyId}`}
      >
        <Button round={true} size={'sm'} color={'warning'}>
          Edit
        </Button>
      </Link>
    );
  }

  getActionButtons(story, storyIndex) {
    return (
      <>
        {this.editButton(story._id, storyIndex)}
        {/*{this.duplicateButton(story._id)}*/}
      </>
    );
  }

  storyTitle(story) {
    return story.storyType
      ? `${story.storyType.toUpperCase()} - ${story.title}`
      : story.title;
  }

  mapUserStoriesToTable() {
    const { userStories } = this.props;
    return userStories.map((story, index) => {
      let storyIndex = index + 1;
      const storyEntry = [];
      storyEntry.push(storyIndex + '');
      storyEntry.push(this.storyTitle(story));
      storyEntry.push(this.getActionButtons(story, storyIndex));
      return storyEntry;
    });
  }

  render() {
    const projectId = this.props.sprint.project;
    const sprintId = this.props.sprint._id;
    console.log();
    if (this.state.redirectToCreateStory) {
      return (
        <Redirect
          to={{
            pathname: `/projects/${projectId}/sprints/${sprintId}/create-story`,
            state: {
              from: "story-list"
            }
          }}
        />
      );
    }
    return (
      <div>
        <Grid container justify='space-between'>
          <div>
            {this.props.sprint.title && (
              <PageTitle title={this.props.sprint.title} />
            )}
            <h5>Sprint's user stories</h5>
          </div>
          <div style={{ paddingRight: '1rem' }}>
            {this.props.sprint.sprintStatus.status === 'Draft' && (
              <>
                <Link
                  to={`/projects/${this.props.sprint.project}/sprints/${
                    this.props.sprint._id
                  }/edit`}
                >
                  <Button round size='sm' color='success'>
                    Edit Sprint
                  </Button>
                </Link>
              </>
            )}
            <Link
              to={`/projects/${projectId}/sprints/${sprintId}/create-story`}
            >
              <Button round size='sm' color='success'>
                Add Story
              </Button>
            </Link>
          </div>
        </Grid>

        <Grid item xs={12}>
          <Table
            striped={true}
            tableHead={['#', 'User Story', 'Actions']}
            tableData={this.mapUserStoriesToTable()}
            customCellClasses={[
              `classes.textLeft`,
              `classes.textLeft`,
              `text-align-right `,
            ]}
            customClassesForCells={[0, 1, 2]}
            customHeadCellClasses={[
              `classes.textLeft`,
              `classes.textLeft`,
              `text-align-right padding-right-4`,
            ]}
            customHeadClassesForCells={[0, 1, 2]}
          />
        </Grid>
        <Grid
          container
          justify='space-between'
          style={{ paddingRight: '1rem' }}
        >
          <Link to={`/projects/${projectId}/`}>
            <Button
              round
              style={{ marginTop: '2rem' }}
              size='sm'
              color='success'
            >
              Back
            </Button>
          </Link>
          <Link
            to={`/projects/${this.props.sprint.project}/sprints/${
              this.props.sprint._id
            }/info`}
          >
            <Button
              round
              style={{ marginTop: '2rem' }}
              size='sm'
              color='danger'
            >
              Review
            </Button>
          </Link>
        </Grid>
      </div>
    );
  }
}

export default StoryList;
